import { inject } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
} from '@angular/common/http';
import { AutenticacaoService } from '../api/autenticacao/autenticacao.api';
import { Router } from '@angular/router';
import { catchError, map, throwError } from 'rxjs';
import { BaseResponse } from '../models/response/base-response';
import { AvisoService } from '../service/aviso/aviso.service';

export const AutenticacaoInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const autenticacaoService = inject(AutenticacaoService);
  const avisoService = inject(AvisoService);
  const router = inject(Router);
  const token = localStorage.getItem('token');

  const authReq = token
    ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
    : req;

  return next(authReq).pipe(
    map((event: HttpEvent<unknown>) => {
      if (event && 'body' in event && event.body && typeof (event.body as BaseResponse<unknown>).status === 'boolean') {
        const response = event.body as BaseResponse<unknown>;
        if (response.semPermissao) {
          router.navigateByUrl('/Dashboard');
          avisoService.Info('Você não tem permissão para acessar essa página!');
        }
      }
      return event;
    }),
    catchError((erro: HttpErrorResponse) => {
      if (erro.status === 401) {
        autenticacaoService.Logout();
        router.navigateByUrl('/Acesso');
      }
      return throwError(() => erro);
    }),
  );
};
